'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _list = require('./list');

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _list2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-list-select/dist/index.js
 ** module id = 1065
 ** module chunks = 0
 **/